import type { UsageMetric } from '../software.types';

export class UsageMetricModel implements UsageMetric {
  private readonly _dto: UsageMetric;
  private readonly _softwareId: string;

  constructor(softwareId: string, dto?: UsageMetric) {
    this._dto = dto || {} as UsageMetric;
    this._softwareId = softwareId;
  }

  get originDTO(): UsageMetric {
    return this._dto;
  }

  public get usageMetricId(): string {
    return this._dto.usageMetricId || '';
  }

  public get usageMetricName(): string {
    return this._dto.usageMetricName || '';
  }

  public get usageMetricCode(): string {
    return this._dto.usageMetricCode || '';
  }

  public get description(): string {
    return this._dto.description || '';
  }

  public get usageUnit(): string {
    return this._dto.usageUnit || '';
  }

  public get isBillable(): boolean {
    return this._dto.isBillable || false;
  }

  public get defaultBillableUsageExpression(): string {
    return this._dto.defaultBillableUsageExpression || '';
  }

  public get defaultCostExpression(): string {
    return this._dto.defaultCostExpression || '';
  }

  public get softwareId(): string {
    return this._softwareId;
  }
}
